import Service from '@/helpers/factoryTourService'

export default {

    register(params) {
        return Service().post('seminar/register', params);
    },
}
